<template>
  <div class="ms-cell-editor combobox">
    <div
      v-show="!isSelected || readOnly"
      :class="{
        'edit-disabled': readOnly,
        'ms-editor-text': editable,
        hasError: errorProvider.isValid,
        'display-error': errorMessage && !isEditor,
        'error-border': errorMessage,
      }"
    >
      <a v-show="!isEditor" class="editor-click" @click="$emit('editorClick', $event, col, colIndex)">
        <span
          class="editor-display"
          :title="[
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              enumName: col.enum,
            }),
          ]"
          >{{
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              enumName: col.enum,
            })
          }}</span
        >
      </a>

      <ms-combobox-enum
        v-if="isEditor"
        v-model:display="dataRow[col.dataField]"
        ref="msCombobox"
        v-model="dataRow[modelValueField]"
        :class="['input-editor']"
        :column="propsData.columns"
        :init-text="initText"
        :selectOnly="propsData.selectOnly"
        :enum="propsData.enum"
        :is-grid-editor="true"
        :dropdown-width="propsData.dropdownWidth"
        v-on="listeners"
        :preventPaste="allowCopyFromExcel"
      ></ms-combobox-enum>

      <div v-show="errorMessage && !isEditor" v-tooltip="errorMessage" class="icon24 error mr-4px"></div>
    </div>
    <div v-show="isSelected && !readOnly" ref="editor" class="ms-editor control-cell"></div>
  </div>
</template>
<script>
import {watch, nextTick, defineExpose, onMounted, getCurrentInstance, ref, inject} from 'vue';
import {useCellEditor} from './CellEditorSetup.js';

export default {
  name: 'MsCellComboboxEnum',
  props: {
    col: {},
    dataRow: {},
    rowIndex: {
      default: 0,
      type: Number,
    },
    colIndex: {
      default: 0,
      type: Number,
    },
    // Thuộc tính để cấu hình cho phép sửa trên grid hay không
    editable: {
      default: true,
      type: Boolean,
    },
    rowSelected: {
      default: null,
    },
    readOnly: {
      default: false,
      type: Boolean,
    },
    // có cho phép show text validate bên dưới cell k
    isShowText: {
      type: Boolean,
      default: false,
    },
    propsData: {
      type: Object,
      default: () => {},
    },
    disabled :{
      default: false,
      type: Boolean,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['pasteInput', 'update:modelValue'],
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    const {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      findEditor,
      getValue,
      validate,
      clearValidate,
      errorMessage,
    } = useCellEditor({
      props,
      emit,
    });

    const allowCopyFromExcel = inject('allowCopyFromExcel');

    const initText = ref('');

    watch(isEditor, newVal => {
      if (newVal) {
        initText.value = proxy.$ms.format.formatData(proxy.dataRow[proxy.col.dataField], {
          formatType: proxy.col.formatType,
          enumName: proxy.col.enum,
        });
        nextTick(() => {
          findEditor();
        });
      }
    });

    const modelValueField = props.propsData.modelValueField || props.propsData.valueField;
    const msCombobox = ref({});
    const getMetaData = () => {
      return msCombobox.value?.internalSelectedItem ? {...msCombobox.value.internalSelectedItem} : {};
    };
    
    /**
     * Gán giá trị cho cell
     */
    const setValue = value => {
      let me = proxy;

      if (me.readOnly) {
        return;
      }

      if (isEditor.value && typeof me.$refs.msCombobox?.setInternalText == 'function') {
        me.$refs.msCombobox.setInternalText(value);
      }

      let enumData = proxy.$ms.commonFn.getEnumSource(proxy.propsData.enum, proxy.propsData.values);

      let findEnum = enumData?.find(x => x.enumText?.trim() == value?.trim());

      if (findEnum) {
        me.dataRow[me.col.dataField] = value;
        me.dataRow[modelValueField] = findEnum.enumValue;
      } else {
        me.dataRow[me.col.dataField] = null;
        me.dataRow[modelValueField] = null;
      }

      me.$emit('update:modelValue', me.dataRow[me.col.dataField]);
    };

    return {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      findEditor,
      getValue,
      validate,
      clearValidate,
      errorMessage,
      initText,
      modelValueField,
      getMetaData,
      msCombobox,
      setValue,
      allowCopyFromExcel,
    };
  },
};
</script>

<style lang="scss" scoped></style>
